import algoliasearch from 'algoliasearch';

// Variables de entorno para mayor seguridad
const ALGOLIA_APP_ID = process.env.REACT_APP_ALGOLIA_APP_ID;
const ALGOLIA_SEARCH_API_KEY = process.env.REACT_APP_ALGOLIA_SEARCH_API_KEY;
const ALGOLIA_USER_INDEX = process.env.REACT_APP_ALGOLIA_INDEX_NAME;
const ALGOLIA_RECIPES_INDEX = process.env.REACT_APP_ALGOLIA_RECIPES_INDEX;

// Cliente Algolia
const client = algoliasearch(ALGOLIA_APP_ID, ALGOLIA_SEARCH_API_KEY);

// Índices
const userIndex = client.initIndex(ALGOLIA_USER_INDEX);
const recipesIndex = client.initIndex(ALGOLIA_RECIPES_INDEX);

// Exporta ambos índices para usarlos donde los necesites
export {userIndex, recipesIndex};